import classNames from "classnames";

export const ProgressBar = ({
  step,
  total,
  className = "",
  singleBarClassName = "",
  colors = ["#008035", "#F7C202"],
}: {
  step: number | number[];
  total?: number;
  singleBarClassName?: string;
  className?: string;
  colors?: string[];
}) => {
  return (
    <div
      className={classNames(
        "relative h-[5px] w-full overflow-hidden rounded-full bg-grey-100",
        className,
        {
          "!bg-transparent":
            typeof step === "object" &&
            step.length > 0 &&
            step.every((val) => val > 0),
        },
      )}
    >
      {typeof step === "number" ? (
        <div
          style={{
            width: `${(step / total!) * 100}%`,
          }}
          className={classNames(
            "absolute inset-0 rounded-full bg-primary transition-all duration-500",
            singleBarClassName,
          )}
        />
      ) : (
        <div className="absolute inset-0 flex items-center gap-[2px] rounded-full transition-all duration-500">
          {step.map((s, idx) => {
            const sTotal = step.reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0,
            );

            return (
              <div
                key={`${idx}`}
                className="h-full rounded-full"
                style={{
                  width: `${(s / sTotal) * 100}%`,
                  background: colors[idx],
                }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
